import { useEffect, useState } from 'react';

import { devMindmapNodesList } from './static';
import { NodeMap } from './types';

export interface Data {
  nodeMap: NodeMap;
  setNodeMap: React.Dispatch<React.SetStateAction<NodeMap>>;
  rootNodeId: string | undefined;
  historizeNextMapChange: boolean;
  sethistorizeNextMapChange: React.Dispatch<React.SetStateAction<boolean>>;
}

type UseData = { id: string };

export const useMindmapData = ({ id }: UseData): Data => {
  const [nodeMap, setNodeMap] = useState<NodeMap>({});
  // cache the current root node id
  const [rootNodeId, setRootNodeId] = useState<string>();
  const [historizeNextMapChange, sethistorizeNextMapChange] = useState<boolean>(false);

  useEffect(() => {
    // TODO: get from backend
    console.info('Loading new mindmap because of id change ...', { id });
    // convert list to object with id as key for faster access
    let map: NodeMap = {};
    // TODO: version handling
    devMindmapNodesList.forEach((node) => (map[node.id] = node));
    setRootNodeId(devMindmapNodesList.find(({ pid }) => pid === null)?.id);
    setNodeMap(map);
    console.info('Loaded new mindmap.', { id, map });
    // don't historize map changes from backend
    sethistorizeNextMapChange(true);
  }, [id]);

  return { nodeMap, setNodeMap, rootNodeId, historizeNextMapChange, sethistorizeNextMapChange };
};
